<template>
  <navbar id="header">
    <router-link tag="a" class="logo" to="/index">
      <img src="@/assets/img/h3c-logo.png" alt="logo" />
    </router-link>
    <ul class="nav header-menus">
      <li
        class="nav-item header-item"
        v-for="(item,index) in headMenus"
        @click="menuChange(item)"
        @mouseover="mouseIndex=index"
        @mouseout="mouseIndex=null"
      >
        <router-link
          v-if="item.child"
          tag="div"
          @mouseover.native="showList=true"
          @mouseout.native="showList=false"
          to=""
          :class="['nav-link',headIndex.toString().split('-')[0]==index.toString()?'router-link-active':'',mouseIndex==index?'mouse-active':'']"
        >
          <p>{{item.name}}</p>
            <!--下拉框-->
            <ul class="menus-list" v-if="headMenus[index]" v-show="mouseIndex==index?true:false" @mouseover="showList=true" @mouseout="showList=false">
              <li v-if="headMenus[index]" v-for="(childItem,childIndex) in headMenus[index].child" :key="childItem.name" @click="changeList(childItem)">
                <router-link tag="div" :to='childItem.link' :class="[headIndex==index.toString()+'-'+childIndex.toString()?'child-link-active':'']">
                {{childItem.name}}
                </router-link>
              </li>
            </ul>
        </router-link>
        <router-link
          v-else
          tag="div"
          :to="item.link"
          :class="['nav-link',headIndex==index.toString()+'-0'?'router-link-active':'',mouseIndex==index?'mouse-active':'']"
        >
          <p>{{item.name}}</p>
        </router-link>
      </li>
    </ul>
  </navbar>
</template>
<script>
import navbar from "./Navbar";
import personal from "./Personal.vue";
import modifyPwd from "./ModifyPwd.vue";

export default {
  name: "CsHeader",
  props: ["headMenus", "headIndex", "userInfo"],
  components: {
    navbar,
    personal,
    modifyPwd
  },
  data() {
    return {
      userAccount: sessionStorage.getItem("userAccount"),
      mouseIndex: null,
      currentOrganization: "",
      radiorganization: "",
      showPersonalModal: false,
      showModifyPwdModal: false,
      showList: false,
      customerModal: false,
      userId: 0,
      userType: 0,
      customerList: []
    };
  },
  methods: {
    cancel() {
      this.customerModal = false;
    },
    LoadCurrentUser() {
      //获取session中个人信息
      this.$http
        .get(this.$apiPrifixUri + "/user/session/")
        .then(res => {
          if (res.code == 0) {
            var curUser = res.data;
            console.log(curUser);
            this.userId = curUser.userId;
            this.userType = curUser.userType;
            this.userAccount = curUser.account;
            this.radiorganization = curUser.orgId;
            this.currentOrganization = curUser.orgName;
            sessionStorage.setItem("userId", curUser.userId);
            this.resetSetItem("userType", curUser.userType);
            sessionStorage.setItem("userAccount", curUser.account);
            sessionStorage.setItem("orgId", curUser.orgId);
            sessionStorage.setItem("orgName", curUser.orgName);
          } else {
            console.error(res.message);
          }
        })
        .catch(error => {
          console.error("获取当前用户信息出现异常！");
        });
    },
    Logout() {
      //登出
      this.$http
        .post(this.$apiPrifixUri + "/logout", {})
        .then(res => {
          if (res.code == 0) {
            this.$router.push("/");
          } else {
            this.$Message.info(res.message);
          }
        })
        .catch(error => {
          this.$Message.error("系统异常，登出失败！");
        });
    },
    openPersonalModal() {
      this.$refs.personal.$refs.personalForm.resetFields();
      this.$refs.personal.initData();
    },
    closePersonalModal() {
      this.showPersonalModal = false;
    },
    confirmPersonalModal() {
      this.$refs.personal.submitForm();
    },
    personalToParent: function(showPersonalModal) {
      if (this.showPersonalModal != showPersonalModal) {
        this.showPersonalModal = showPersonalModal;
      }
    },
    openModifyPwdModel() {
      this.$refs.modifyPwd.$refs.modifyPwdForm.resetFields();
      this.$refs.modifyPwd.initData();
      this.showModifyPwdModal = true;
    },
    confirmModifyPwdModal() {
      this.$refs.modifyPwd.submitForm();
    },
    modifyPwdToParent: function(showModifyPwdModal) {
      if (this.showModifyPwdModal != showModifyPwdModal) {
        this.showModifyPwdModal = showModifyPwdModal;
      }
    },
    Customer() {
      this.getApiData("get", "/organization/names", {}, res => {
        this.customerList = res.data;
        this.customerModal = true;
      });
    },
    asideToggle(e) {
      jq("body").toggleClass("aside-menu-hidden");
      this.$emit("updateChart", !jq("body").hasClass("aside-menu-hidden"));
    },
    menuChange(item) {
      this.$emit("menuChange", item);
    },
    changeList(item) {
      this.showList = false;
    },
    selectCustomer() {
      this.customerModal = false;
      let data = {
        id: this.radiorganization,
        name: ""
      };
      for (let key in this.customerList) {
        if (this.customerList[key].id == data.id) {
          data.name = this.customerList[key].name;
        }
      }
      this.getApiData("post", "/organization/select", data, res => {
        this.currentOrganization = data.name;
        sessionStorage.setItem("orgId", this.radiorganization);
        sessionStorage.setItem("orgName", this.currentOrganization);
        this.$router.go(0);
      });
    },
    changeStyle(e) {
      e.currentTarget.className = "mouseover-header";
      console.log(e.target);
      console.log(e.currentTarget);
    }
    //getUserAccount(){
    //	this.userAccount = sessionStorage.getItem("userAccount");
    //}
  },
  mounted() {
    //this.getUserAccount();
    // this.LoadCurrentUser();
    window.addEventListener("setorgName", () => {
      this.currentOrganization = sessionStorage.getItem("orgName");
    });
  },
  computed: {
    getMessage() {
      return this.$store.state.unreadMessage == 0
        ? ""
        : this.$store.state.unreadMessage;
    },
    detailUrl() {
      return this.$store.state.user.detailUrl;
    },
    updateFlag() {
      return this.$store.state.headerFlag;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/header/CsHeader.vue